import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderManagementListContainer from '../../containers/order/OrderManagementListContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderManagementList = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_MANAGEMENT_LIST}>
      <OrderManagementListContainer />
    </PageTemplate>
  );
};

export default OrderManagementList;
